import { router } from "expo-router";
import React from "react";
import { ScrollView, Text, View } from "react-native";
import ResponsiveContent from "@/elements/components/shared/responsive-content";
import ProfileLogoutItem from "../profile/profile-logout-item";
import AccountItem from "./account-item";
import AccountItemDivider from "./account-item-divider";

function TutorAccount() {
  return (
    <View className="flex-1 bg-teachLoop-creamBase">
      <ScrollView showsVerticalScrollIndicator={false}>
        <ResponsiveContent>
          <View className="h-3" />
          <View className="mx-5">
            <View className="gap-1">
              <Text className="font-zilla-slab-medium font-medium text-dark text-[32px] leading-[1.2]">
                Account
              </Text>
              <Text className="font-geologica-regular font-normal text-[20px] text-gray-800 leading-[1.5]">
                Manage your Profile details, chat with parents and see lesson
                history
              </Text>
            </View>
          </View>
          <View className="h-8" />

          <AccountItemDivider />
          <AccountItem
            title="Profile details"
            onPress={() => {
              router.push("/(app)/profile-settings");
            }}
          />

          <AccountItemDivider />
          <AccountItem
            title="Lesson history"
            onPress={() => {
              router.push("/(app)/lesson-history");
            }}
          />

          <AccountItemDivider />
          <AccountItem
            title="My reviews"
            onPress={() => {
              router.push("/(app)/my-reviews");
            }}
          />

          <AccountItemDivider />
          <AccountItem
            title="Account settings"
            onPress={() => {
              router.push("/(app)/account-settings");
            }}
          />

          <AccountItemDivider />
          <AccountItem
            title="Resources"
            onPress={() => {
              router.push("/(app)/resources");
            }}
          />

          <AccountItemDivider />
          <AccountItem
            title="Legal Documents"
            onPress={() => {
              router.push("/(app)/legal-documents");
            }}
          />

          <AccountItemDivider />
          <ProfileLogoutItem />

          <AccountItemDivider />
          <View className="h-8" />
        </ResponsiveContent>
      </ScrollView>
    </View>
  );
}

export default TutorAccount;
